<template>
  <div>
    <div class="ag-header row d-flex align-items-center" :key="compKey">
      <div
        class="col-xl-10 col-lg-10 d-flex"
        style="align-items: center"
        v-if="!showGlobal"
      >
        <span
          @click.prevent="sidebarStatus()"
          class="menu-icon cursor-pointer d-inline-block"
          ><i class="ag-icon ag-icon_menu"></i>
        </span>

        <div class="main-header d-flex align-items-center">
          <span class="global" v-if="loggedInUser.role === Roles.AGMSAdmin">
            {{$t("global")}}
          </span>
          <span class="global" v-if="loggedInUser.role === Roles.PartnerAdmin">
            Partner: {{ partner.name }}
          </span>
          <div
            class="no-wrap"
            v-if="company && loggedInUser.role === Roles.CompanyAdmin"
          >
            <span class="selected-group"> {{$t("company")}} : </span>
            <span class="company">
              {{ company.companyName || company.value }}</span
            >
          </div>
          <div
            class="no-wrap"
            v-if="selectedGroup && loggedInUser.role === Roles.GroupAdmin"
          >
            <span class="selected-group"> {{$t("group")}} : </span>
            <span class="company"> {{ selectedGroup.value }}</span>
          </div>
          <div
            class="no-wrap"
            v-if="selectedSite && loggedInUser.role === Roles.SiteAdmin"
          >
            <span class="selected-group"> {{$t("site")}} : </span>
            <span class="company"> {{ selectedSite.value }}</span>
          </div>
          <button
            class="ag-button change-scope"
            @click="openChangeScopeModal()"
          >
            {{$t("changeScope")}}
          </button>
        </div>

        <div
          class="main-header-breadcrumb"
          v-if="
            ([Roles.AGMSAdmin, Roles.PartnerAdmin, Roles.CompanyAdmin, Roles.SiteAdmin].includes(
              loggedInUser.role
            ) &&
              !agmsBreadcrumbStatus) ||
            [Roles.GroupAdmin].includes(loggedInUser.role)
          "
        >
          <!-- <div class="ml-3 dropdown" v-role="[Roles.AGMSAdmin]">
          <button
            class="ag-button_text border-0 dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ company.companyName || company.value }}
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a
              v-for="(item, key) in companies"
              :key="key"
              class="dropdown-item"
              @click="selectCompany(item)"
              href="#"
              >{{ item.value }}</a
            >
          </div>
        </div> -->
          <div
            class="ml-3 dropdown"
            v-role="[
              Roles.GroupAdmin,
              Roles.GroupAudit,
              Roles.SiteAdmin,
              Roles.SiteAudit,
              Roles.CompanyAdmin,
            ]"
          >
            <span
              class="ag-button_text border-0 text-decoration-none"
              v-if="company"
              style="
                position: relative;
                padding-right: 10px;
                display: inline-block;
              "
            >
              {{ company.companyName }}
              <i
                v-role="[
                  Roles.GroupAdmin,
                  Roles.GroupAudit,
                  Roles.SiteAdmin,
                  Roles.SiteAudit,
                ]"
                style="
                  font-style: normal;
                  padding-left: 10px;
                  font-size: 25px;
                  position: absolute;
                  right: -8px;
                  top: -7.5px;
                "
                >></i
              >
            </span>
          </div>
          <div
            class="ml-3 dropdown"
            v-role="[Roles.SiteAdmin]"
            v-if="sites && sites.length > 1"
          >
            <span class="ag-button_text border-0 text-decoration-none">
              {{ site?.value }}
            </span>
          </div>
          <div class="ml-3 dropdown" v-role="[Roles.SiteAdmin]" v-else>
            <span
              class="ag-button_text border-0 text-decoration-none"
              v-if="site"
            >
              {{ site?.value }}
            </span>
          </div>
          <div class="ml-3 dropdown" v-role="[Roles.GroupAdmin]">
            <span
              class="ag-button_text border-0 text-decoration-none"
              style="
                position: relative;
                padding-right: 10px;
                display: inline-block;
              "
            >
              {{ site?.value }}
              <i
                style="
                  font-style: normal;
                  padding-left: 10px;
                  font-size: 25px;
                  position: absolute;
                  right: -8px;
                  top: -7.5px;
                "
                >></i
              >
            </span>
          </div>
          <div
            class="ml-3 dropdown"
            v-role="[Roles.GroupAdmin]"
            v-if="groups && groups.length > 1"
          >
            <span class="ag-button_text border-0 text-decoration-none">
              {{ group?.value }}
            </span>
          </div>
          <div class="ml-3 dropdown" v-role="[Roles.GroupAdmin]" v-else>
            <span
              class="ag-button_text border-0 text-decoration-none"
              v-if="group"
            >
              {{ group?.value }}
            </span>
          </div>
        </div>
        <AgAgmsBredcrumb
          v-role="[Roles.AGMSAdmin, Roles.PartnerAdmin, Roles.CompanyAdmin, Roles.SiteAdmin]"
          v-if="agmsBreadcrumbStatus"
        />
      </div>

      <div
        class="col-xl-10 col-lg-10 d-flex"
        style="align-items: center"
        v-if="showGlobal"
      >
        <span class="menu-icon cursor-pointer d-inline-block">
          <i class="ag-icon ag-icon_public"></i>
        </span>
        <div class="ml-2 dropdown">
          <span style="color: #164b6c; font-weight: bold">{{$t("global")}}</span>
        </div>
      </div>
      <div
        class="
          col-xl-2 col-lg-2
          mt-sm-3 mt-xl-0 mt-3
          d-flex
          justify-content-end
          nav-right
        "
      >
        <div class="d-flex">
          <!-- <a href="#" class="mr-2">
          <span style="margin-top: 8px;" class="ag-icon ag-icon_alarm"></span>
        </a> -->
          <!--        <button type="button"  @click="agmsLogout()" class="ag-link border-0">{{ user }}</button>-->

          <li
            style="list-style-type: none !important"
            class="nav-item dropdown language-switcher"
          >
            <a
              class="nav-link dropdown-toggle"
              href="javascript:;"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              {{ selectedLanguage.toUpperCase() }}
            </a>
            <ul
              style="list-style-type: none !important"
              class="dropdown-menu"
              aria-labelledby="navbarDropdown"
            >
              <li v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
                <a
                  class="dropdown-item"
                  href="javascript:;"
                  @click="setLanguage(lang)"
                  >{{ lang.toUpperCase() }}</a
                >
              </li>
            </ul>
          </li>
          <li
            style="list-style-type: none !important"
            class="nav-item dropdown"
          >
            <a
              class="nav-link dropdown-toggle"
              href="javascript:;"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              {{ loggedInUser.name }}
            </a>
            <ul
              style="list-style-type: none !important"
              class="dropdown-menu"
              aria-labelledby="navbarDropdown"
            >
              <li>
                <router-link class="dropdown-item" to="/profile"
                  >{{$t("profile")}}</router-link
                >
              </li>
              <li><hr class="dropdown-divider" /></li>
              <li>
                <a href="javascript:;" class="dropdown-item" @click="logout">{{$t("logout")}}</a>
              </li>
            </ul>
          </li>
        </div>
      </div>
      <iframe
        v-if="(loggedInUser.role === Roles.AGMSAdmin || loggedInUser.role === Roles.PartnerAdmin) && agmsCompanyOverviewUrl"
        :src="agmsCompanyOverviewUrl"
        style="display: none !important"
      />
      <iframe
        v-role="[Roles.CompanyAdmin, Roles.SiteAdmin, Roles.GroupAdmin]"
        :src="agmsURL"
        style="display: none !important"
        v-if="isVisit"
      />
      <iframe
        v-if="isLogout"
        :src="agmsLogOut"
        style="display: none !important"
      />
    </div>
    <ag-scope-modal></ag-scope-modal>
  </div>
</template>

<script>
import { ref } from "vue";
import { mapState, mapActions, mapGetters } from "vuex";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { AuthActionTypes } from "@/store/modules/auth/action-types";
import { useStore } from "@/store";
import AgAgmsBredcrumb from "@/components/ag-agms-breadcrumb/index.vue";
import { useI18n } from "vue-i18n";
import { Roles } from "@/helpers/enums/Roles";
import { GeneralMutationTypes } from "@/store/modules/general/mutation-types";
import AgScopeModal from "@/components/ag-scope-modal/index.vue";
import Swal from "sweetalert2";
const store = useStore();
const jQuery = window.jQuery;

export default {
  components: { AgAgmsBredcrumb, AgScopeModal },
  data() {
    return {
      Roles: Roles,
      site: null,
      group: null,
      selectedLanguage: localStorage.getItem("selectedLanguage")
        ? localStorage.getItem("selectedLanguage")
        : "en",
      langs: ["ja", "en"],
      selectedSite: null,
      selectedGroup: null,
      logoutTime: null,
      minutes: null,
      seconds: null,
      
    };
  },
  computed: {
    ...mapState({
      sidebarStatus: (state) => state.general.sidebarStatus,
      agmsGroup: (state) => state.auth.agmsGroup,
      agmsSite: (state) => state.auth.agmsSite,
      agmsBreadcrumbStatus: (state) => state.general.agmsBreadcrumbStatus,
    }),
    ...mapGetters([
      "loggedInUser",
      "partner",
      "company",
      "companies",
      "sites",
      "groups",
      "alert",
      "compKey",
    ]),
    agmsCompanyOverviewUrl() {
      const agmsUrl = process.env.VUE_APP_AGMS_URL;
      const companyGuid = this.company.companyGuid;
      if (companyGuid) {
        return (
          agmsUrl +
          `/MultiTenant/ManageCompany/AGMSDashboard?companyId=${companyGuid.replaceAll('_', '-')}`
        );
      }
      return false;
    },
    agmsURL() {
      return process.env.VUE_APP_AGMS_URL;
    },
    agmsLogOut() {
      return process.env.VUE_APP_AGMS_URL + `/Account/LogOff?sid=${this.loggedInUser.sid}`;
    },
  },
  setup() {
    /*Set Sidebar Status*/
    const sidebarStatus = () => {
      let status =
        store.state.general.sidebarStatus === "closed" ? "open" : "closed";
      store.dispatch(GeneralActionTypes.SIDEBAR_STATUS, status);
    };

    const visit = localStorage.getItem("visit");
    const isVisit = ref(false);
    const isLogout = ref(false);
    isVisit.value = visit != undefined;

    localStorage.setItem("visit", "1");

    const { locale } = useI18n();

    let alertMutation = () => {
      store.commit(GeneralMutationTypes.SET_ALERT, {
        status: false,
        options: {},
      });
    };
    return {
      alertMutation,
      locale,
      sidebarStatus,
      isVisit,
      isLogout
    };
  },
  watch: {
    $route() {
      if (this.alert.status) {
        this.alertMutation();
      }
    },
    compKey() {
      this.getData();
    },
  },
  async created() {
    await Promise.all([this.getSections()]);
  },
  mounted() {
    this.setLanguage(this.selectedLanguage);
    this.getData();
  },
  methods: {
    ...mapActions({
      setSideBarStatus: GeneralActionTypes.SIDEBAR_STATUS,
      setCompany: AuthActionTypes.SET_COMPANY,
      setSite: AuthActionTypes.SET_SITE,
      setGroup: AuthActionTypes.SET_GROUP,
      getSites: GeneralActionTypes.GET_SITES,
      getGroups: GeneralActionTypes.GET_GROUPS,
      getSections: GeneralActionTypes.GET_SECTIONS,
    }),
    openChangeScopeModal() {
      store.commit(GeneralActionTypes.SET_SCOPE_MODAL, false);
      jQuery("#scopeModal").modal("toggle");
      setTimeout(() => {
        store.commit(GeneralActionTypes.SET_SCOPE_MODAL, true);
      }, 120);
    },
    setLanguage(lang) {
      this.selectedLanguage = lang;
      localStorage.setItem("selectedLanguage", this.selectedLanguage);
      this.locale = this.selectedLanguage;
    },
    selectGroup(group) {
      this.setGroup(group);
      location.reload();
    },
    selectSite(site) {
      this.setSite(site);
      location.reload();
    },
    selectCompany(company) {
      this.setCompany(company);
      if (this.$route.name === "threat") {
        location.href = "/hash-inspection/malicious";
      } else {
        location.reload();
      }
    },
    getData() {
      setTimeout(() => {
        try {
          this.selectedSite = JSON.parse(localStorage.getItem("site"));
          this.site = this.selectedSite;
        } catch (error) {
          console.log(error);
        }
        try {
          this.selectedGroup = JSON.parse(localStorage.getItem("group"));
          this.group = this.selectedGroup;
        } catch (error) {
          console.log(error);
        }
      }, 300);
    },
    logout() {
      Swal.fire({
        title: "Log out from the Session",
        icon: "warning",
        text: "Do you want to log out from the session ?",
        showCancelButton: true,
        confirmButtonText: "Yes, Log out",
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLogout = true;          
          localStorage.clear();
          sessionStorage.clear();
          location.href = "/bff/logout?sid=" + this.loggedInUser.sid;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-header {
  background: #e3e7eb 0% 0% no-repeat padding-box;
  margin-left: -25px;
  margin-right: -25px;
  padding: 18px 12px;

  .ag-button_text {
    white-space: nowrap;
  }

  .no-wrap {
    white-space: nowrap;
  }

  .nav-right a {
    font: normal normal normal 14px/17px Open Sans;
    letter-spacing: 0px;
    color: #164b6c;
  }

  .menu-icon {
    margin-right: 24px;
  }

  .global {
    font: normal normal 600 21px/33px Open Sans;
    letter-spacing: 0px;
    color: #7294a8;
  }

  .selected-group {
    font: normal normal 600 21px/33px Open Sans;
    letter-spacing: 0px;
    color: #a6bbc6;
  }

  .company {
    font: normal normal 600 21px/33px Open Sans;
    letter-spacing: 0px;
    color: #7294a8;
    margin-left: 5px;
  }

  .change-scope {
    background: #edeff2 0% 0% no-repeat padding-box;
    border: 1px solid #b7c6cd;
    border-radius: 5px;
    font: normal normal normal 11px/15px Open Sans;
    letter-spacing: 0px;
    color: #7294a8;
    padding: 5px 12px;
    margin-left: 12px;
    box-shadow: none;
  }
}
</style>
